import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

function noop() {}

const BubbleContent = ({
  ariaCurrent,
  ariaLabel,
  number = 1,
  className,
  status = 'default',
  onClick = noop,
  disabled = false,
  size = 'default',
  backgroundColor,
  color = 'default',
}) => {
  return (
    <button
      aria-current={ariaCurrent}
      aria-label={ariaLabel}
      className={clsx('bubble-content', className, `bubble-content--${status}`, `bubble-content--size-${size}`, `bubble-content--color-${color}`, {
        'bubble-content--disabled': disabled,
      })}
      onClick={onClick}
      disabled={disabled}
      style={{ backgroundColor: backgroundColor }}
      type="button"
    >
      <div className="bubble-content__content">{number}</div>
    </button>
  );
};

BubbleContent.propTypes = {
  ariaCurrent: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['page', 'step', 'location', 'date', 'time'])]),
  ariaLabel: PropTypes.string,
  backgroundColor: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.element]),
  status: PropTypes.oneOf(['default', 'fill', 'bordered', 'current']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['s', 'default', 'm', 'xl']),
  color: PropTypes.oneOf(['default', 'white', 'primary', 'fill-white', 'gray', 'green', 'dark']),
};

export default BubbleContent;
